/** Remaining lock time for the sign-in screen. Seconds come from the login API. */

export function formatLockoutCountdown(totalSeconds) {
  const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0))
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60
  const pad = (value) => String(value).padStart(2, '0')
  if (hours > 0) return `${hours}h ${pad(minutes)}m ${pad(secs)}s`
  if (minutes > 0) return `${minutes}m ${pad(secs)}s`
  return `${secs}s`
}

export function lockoutMessage(totalSeconds) {
  const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0))
  if (seconds <= 0) return 'The lock has ended. You can sign in again.'
  return `Account temporarily locked due to repeated failed login attempts. You can try again in ${formatLockoutCountdown(seconds)}.`
}
